import { Col, FloatingLabel, Row, Card } from "react-bootstrap";
import { Form, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import PageLayout from "../../../layouts/PageLayout";
import { Link } from "react-router-dom";
import axios from "axios";

export default function PersonalDetails() {
  const [formState, setFormState] = useState({
    dateOfVisit: "",
    family: "",
    personName: "",
    mobileNum: "",
    identifier: "",
    followUp: "",
    comment: "",
    needs: "",
    img_1: null,
    img_2: null,
    img_3: null,
  });

  const [preview, setPreview] = useState({
    img_1: null,
    img_2: null,
    img_3: null,
  });

  const [followupStatuses, setFollowupStatuses] = useState([]);
  const [people, setPeople] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [answersText, setAnswersText] = useState({});
  const [answersFile, setAnswersFile] = useState({});

  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

  // ✅ Fetch initial data
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_URL + "/followup-form-initial-data")
      .then((res) => {
        setFollowupStatuses(res.data.followup_statuses);
        setPeople(res.data.people);
        setQuestions(res.data.questions);
      })
      .catch((err) => console.error(err));
  }, []);

  // ✅ Handle form changes
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      const file = files[0];
      setFormState((prevState) => ({ ...prevState, [name]: file }));
      setPreview((prev) => ({
        ...prev,
        [name]: file ? URL.createObjectURL(file) : null,
      }));
    } else if (name === "family") {
      const selectedPerson = people.find((p) => p.id == value);
      setFormState((prevState) => ({
        ...prevState,
        family: value,
        personName: selectedPerson ? selectedPerson.beneficiary_name : "",
        mobileNum: selectedPerson ? selectedPerson.mob : "",
      }));
    } else {
      setFormState((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  // ✅ Handle form submit
 const handleSubmit = async (e) => {
  e.preventDefault();

  const formData = new FormData();
  formData.append("person_id", formState.family);
  formData.append("follow_up_id", formState.followUp);
  formData.append("date_of_visit", formState.dateOfVisit);
  formData.append("comment", formState.comment || "");
  formData.append("needs", formState.needs || "");

  // Main images
  if (formState.img_1) formData.append("family_home_image", formState.img_1);
  if (formState.img_2) formData.append("family_business_image", formState.img_2);
  if (formState.img_3) formData.append("children_school_image", formState.img_3);

  // Questions & answers
  Object.keys(answers).forEach((qid) => {
    formData.append("questions[]", qid);
    formData.append(`ans[${qid}]`, answers[qid]);

    if (answersText[qid]) {
      formData.append(`ans_text[${qid}]`, answersText[qid]);
    }

    if (answersFile[qid]) {
      formData.append(`files[${qid}]`, answersFile[qid]);
    }
  });

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/store-family-followup`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${AuthToken}`,
        },
      }
    );

    if (res.data.success) {
      alert("✅ " + res.data.message);
      // Reset form
      setFormState({
        dateOfVisit: "",
        family: "",
        personName: "",
        mobileNum: "",
        identifier: "",
        followUp: "",
        comment: "",
        needs: "",
        img_1: null,
        img_2: null,
        img_3: null,
      });
      setPreview({ img_1: null, img_2: null, img_3: null });
      setAnswers({});
      setAnswersText({});
      setAnswersFile({});
    }
  } catch (err) {
    console.error(err);
    alert("❌ Error submitting follow-up form");
  }
};


  const familyPics = [
    { field: "img_1", text: "Add Home Image", icon: "house" },
    { field: "img_2", text: "Add Family Business Image", icon: "apartment" },
    { field: "img_3", text: "Add Children School Image", icon: "school" },
  ];

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                <i className="material-icons">family_restroom</i> Add Family
                Follow Up
              </h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link
                    to="/"
                    className="mc-breadcrumb-link"
                    style={{ color: "#077834" }}
                  >
                    Home
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">Family Follow Up</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>

      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          {/* Date of Visit */}
          <Form.Group as={Col} md="4" controlId="dateOfVisit">
            <FloatingLabel label="Date Of Visit" className="mb-3">
              <Form.Control
                required
                type="date"
                placeholder="Date of Visit"
                onChange={handleChange}
                name="dateOfVisit"
                value={formState.dateOfVisit}
              />
            </FloatingLabel>
          </Form.Group>

          {/* Family / Person */}
          <Form.Group as={Col} md="4" controlId="family">
            <FloatingLabel label="Select Family / Person" className="mb-3">
              <Form.Select
                required
                name="family"
                value={formState.family}
                onChange={handleChange}
              >
                <option value="">Select...</option>
                {people.map((person) => (
                  <option key={person.id} value={person.id}>
                    {person.beneficiary_name} ({person.f_number})
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Form.Group>

          {/* Person Name */}
          <Form.Group as={Col} md="4">
            <FloatingLabel label="Person's Name" className="mb-3">
              <Form.Control
                required
                type="text"
                name="personName"
                placeholder="Person's Name"
                value={formState.personName}
                readOnly
              />
            </FloatingLabel>
          </Form.Group>

          {/* Mobile */}
          <Form.Group as={Col} md="4">
            <FloatingLabel label="Mobile Number" className="mb-3">
              <Form.Control
                required
                type="text"
                name="mobileNum"
                placeholder="Mobile Number"
                value={formState.mobileNum}
                readOnly
              />
            </FloatingLabel>
          </Form.Group>

          {/* Follow Up */}
          <Form.Group as={Col} md="4">
            <FloatingLabel label="Select Follow Up" className="mb-3">
              <Form.Select
                required
                name="followUp"
                value={formState.followUp}
                onChange={handleChange}
              >
                <option value="">Select...</option>
                {followupStatuses.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Form.Group>

          {/* Comment */}
          <Form.Group as={Col} md="6">
            <FloatingLabel label="Comments" className="mb-3">
              <Form.Control
                as="textarea"
                rows={3}
                name="comment"
                value={formState.comment}
                onChange={handleChange}
                placeholder="Enter any comments"
              />
            </FloatingLabel>
          </Form.Group>

          {/* Needs */}
          <Form.Group as={Col} md="6">
            <FloatingLabel label="Needs" className="mb-3">
              <Form.Control
                as="textarea"
                rows={3}
                name="needs"
                value={formState.needs}
                onChange={handleChange}
                placeholder="Enter needs or requests"
              />
            </FloatingLabel>
          </Form.Group>
        </Row>

        {/* Images Upload */}
        <Row>
          {familyPics.map((field) => (
            <Col key={field.field} md={4} className="mb-4">
              <Card>
                <Card.Body>
                  <Card.Title>
                    <small>{field.text}</small>
                  </Card.Title>
                  <label
                    htmlFor={`file-input-${field.field}`}
                    style={{
                      width: "100%",
                      height: "150px",
                      border: "1px dashed #ddd",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: "10px",
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    {preview[field.field] ? (
                      <img
                        src={preview[field.field]}
                        alt="preview"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "5px",
                        }}
                      />
                    ) : (
                      <i
                        className="material-icons upload-icon"
                        style={{ color: "#077834", fontSize: "40px" }}
                      >
                        {field.icon}
                      </i>
                    )}
                  </label>
                  <input
                    id={`file-input-${field.field}`}
                    type="file"
                    style={{ display: "none" }}
                    accept="image/*"
                    name={field.field}
                    onChange={handleChange}
                  />
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        {/* QUESTIONS SECTION */}
        {questions.length > 0 && (
          <Row className="mt-4">
            <Col md={12}>
              <h4 className="mb-3">Follow-up Questions</h4>

              {questions.map((q) => (
                <Card key={q.id} className="mb-3">
                  <Card.Body>
                    <b>{q.question}</b>

                    {/* YES / NO */}
                    <div className="mt-3">
                      <Form.Check
                        inline
                        label="Yes"
                        name={`question_${q.id}`}
                        type="radio"
                        checked={answers[q.id] === 1}
                        onChange={() => setAnswers({ ...answers, [q.id]: 1 })}
                      />
                      <Form.Check
                        inline
                        label="No"
                        name={`question_${q.id}`}
                        type="radio"
                        checked={answers[q.id] === 0}
                        onChange={() => setAnswers({ ...answers, [q.id]: 0 })}
                      />
                    </div>

                    {/* TEXT ANSWER */}
                    {answers[q.id] === 1 && q.file === 0 && (
                      <Form.Control
                        className="mt-2"
                        placeholder="Enter details"
                        onChange={(e) =>
                          setAnswersText({ ...answersText, [q.id]: e.target.value })
                        }
                      />
                    )}

                    {/* FILE ANSWER */}
                    {answers[q.id] === 1 && q.file === 1 && (
                      <Form.Control
                        className="mt-2"
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          setAnswersFile({ ...answersFile, [q.id]: e.target.files[0] })
                        }
                      />
                    )}
                  </Card.Body>
                </Card>
              ))}
            </Col>
          </Row>
        )}

        {/* Submit Button */}
        <Button type="submit" variant="success" className="mt-3">
          Submit Follow Up
        </Button>
      </Form>
    </PageLayout>
  );
}
